import {
  configApiRef,
  IdentityApi,
  identityApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import {
  CustomFieldExtensionSchema,
  FieldExtensionComponentProps,
} from '@backstage/plugin-scaffolder-react';
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';
import { FieldValidation } from '@rjsf/utils';
import { useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';

let formContext: any;
let ownerInfo: any;
let config: any;
let identity: IdentityApi;
export const GovernanceGroupMembershipExtensionSchema: CustomFieldExtensionSchema =
  {
    returnValue: { type: 'string' },
  };

export const GovernanceGroupMembership = ({
  onChange,
  rawErrors,
  required,
  formData,
  formContext: customFormContext,
}: FieldExtensionComponentProps<string>) => {
  config = useApi(configApiRef);
  identity = useApi(identityApiRef);

  const { formData: customFormData } = customFormContext;
  ownerInfo = customFormData.teamOwner?.trim();
  const ownerEmail = customFormData.teamOwner?.trim();
  const [error, setError] = useState('');
  // const [owner, setOwner] = useState(ownerValue);

  // formContext = useForm({
  //   mode: 'onBlur',
  //   reValidateMode: 'onChange',
  //   shouldUnregister: true,
  //   defaultValues: {
  //     governance_group_membership: [''],
  //   },
  // });

  return (
    <div>
      <h3>Governance member email address</h3>
      <Grid style={{ margin: '2px 2px 2px 2px' }}>
        <FormControl
          margin="normal"
          required={required}
          error={rawErrors !== undefined && rawErrors.length > 0 && !formData}
        >
          <TextField
            label={<strong>Governance member email address *</strong>}
            id="governanceGroupMembershipInput"
            defaultValue={formData}
            onChange={e => {
              const inputEmail = e.target.value?.trim();
              if (ownerEmail?.toLowerCase() === inputEmail.toLowerCase()) {
                setError(
                  'Owner will be automatically added to the governance group. Please select a different member email',
                );
              } else {
                setError('');
              }
              onChange(e.target?.value?.trim());
            }}
            fullWidth
            style={{ width: '550px', margin: '-15px 5px -5px -5px' }}
            variant="outlined"
            helperText={error}
            error={!!error}
          />
        </FormControl>
      </Grid>
    </div>
  );
};

export const OwnershipExtensionSchema: CustomFieldExtensionSchema = {
  returnValue: { type: 'string' },
};

export const OwnerMember = ({
  onChange,
  rawErrors,
  required,
  formData,
  formContext: customFormContext,
}: FieldExtensionComponentProps<string>) => {
  config = useApi(configApiRef);
  identity = useApi(identityApiRef);
  // const classes = useStyles();
  const { formData: customFormData } = customFormContext;
  const governanceMembers = customFormData.governanceTeamMembers;
  const [error, setError] = useState('');

  return (
    <div>
      <h3>Ownership</h3>
      <Grid style={{ margin: '-30px -200px 5px 5px' }}>
        <FormControl
          margin="normal"
          // className={classes.margin}
          required={required}
          error={rawErrors !== undefined && rawErrors.length > 0 && !formData}
        >
          <TextField
            label={<strong>Owner email address *</strong>}
            defaultValue={formData}
            onChange={e => {
              const inputEmail = e.target.value?.trim();
              if (
                governanceMembers.some(
                  (m: string) => m.toLowerCase() === inputEmail.toLowerCase(),
                )
              ) {
                setError(
                  'This owner will be automatically added to the governance group. Please remove it from the governance group members',
                );
              } else if (
                !/[A-Za-z0-9.]+((@principal.com)|(@cuprum.cl))(?:,(?=[A-Za-z0-9.]+((@principal.com)|(@cuprum.cl))))*/.test(
                  inputEmail,
                )
              ) {
                setError(
                  'Invalid Principal/Cuprum email. e.g. lastname.firstname@principal.com or email@cuprum.cl',
                );
              } else {
                setError('');
              }
              onChange(e.target?.value?.trim());
            }}
            fullWidth
            style={{ width: '600px', margin: '10px 5px 5px -5px' }}
            variant="outlined"
            helperText={error}
            error={!!error}
          />
          <Typography variant="body2">
            This person will be responsible for the administration of
            IdentityNow, governance profiles, and groups.
          </Typography>
          <Typography variant="body2" style={{ fontWeight: 700 }}>
            This person will be automatically added to the governance group.
          </Typography>
        </FormControl>
      </Grid>
    </div>
  );
};

export const OrgExtensionSchema: CustomFieldExtensionSchema = {
  returnValue: { type: 'string' },
};

export const OrgName = ({
  onChange,
  rawErrors,
  required,
  formData,
}: FieldExtensionComponentProps<string>) => {
  const defaultOrgUnit = useMemo(() => {
    const org = formData ?? [];

    return org;
  }, [formData]);

  formContext = useForm({
    defaultValues: {
      orgUnit: defaultOrgUnit,
    },
  });

  const triggerOnChange = () => {
    const { orgUnit } = formContext.getValues();

    onChange(`${orgUnit}`);
  };

  const onOrgChange = (e: any) => {
    formContext.setValue('orgUnit', e.target?.value ?? '');
    triggerOnChange();
  };

  const OrgEnum: { [key: string]: string } = {
    CHILE: 'principalchile-emu',
    DESIGNSYSTEM: 'principaldesignsystem-emu',
    DRUPAL: 'principaldrupal-emu',
    EBS: 'principalebs-emu',
    EBSDIGITALADVICE: 'principalebsdigitaladvice-emu',
    EDA: 'principaleda-emu',
    GLOBALASSETMANAGEMENT: 'principalglobalassetmanagement-emu',
    HONGKONG: 'principalhongkong-emu',
    IDI: 'principalidi-emu',
    IS: 'principalinformationservices-emu',
    MAINFRAME: 'principalmainframe-emu',
    MEXICO: 'principalmexico-emu',
    NQIT: 'principalnqit-emu',
    PFG: 'principalfinancialgroup-emu',
    RIS: 'principalris-emu',
    SBX: 'principalsbx-emu',
    SEASIA: 'principalseasia-emu',
    USIS: 'principalusis-emu',
  };

  return (
    <div>
      <h3>GitHub Location</h3>
      <Typography>
        Choose the GitHub org (EMU) where this team should be built initially.
      </Typography>
      <h4>GitHub Org (EMU)</h4>
      <FormControl
        required={required}
        error={rawErrors !== undefined && rawErrors.length > 0 && !formData}
        variant="outlined"
      >
        <InputLabel id="org-unit-label" style={{ fontWeight: 700 }}>
          Organization
        </InputLabel>
        <Select
          value={defaultOrgUnit}
          id="org-unit-select"
          labelId="org-unit-label"
          labelWidth={110}
          onChange={onOrgChange}
          style={{ minWidth: '300px' }}
        >
          {Object.keys(OrgEnum).map((enumKey: any) => (
            <MenuItem key={enumKey} value={enumKey}>
              {OrgEnum[enumKey]}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export const validateTextField = async (
  value: string,
  validation: FieldValidation,
): Promise<void> => {
  const regex =
    '[A-Za-z0-9.]+((@principal.com)|(@cuprum.cl))(?:,(?=[A-Za-z0-9.]+((@principal.com)|(@cuprum.cl))))*';
  const regexp = new RegExp(regex);
  const isRegexValid = regexp.test(value);
  if (!isRegexValid) {
    validation.addError('Please provide a Principal or Cuprum email address');
  } else {
    const { token } = await identity.getCredentials();
    const backendHost = await config.getString('backend.baseUrl');
    const params = new URLSearchParams();
    params.append('email', value);
    const idnResponse = await fetch(`${backendHost}/api/validation/fte`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: `{"emails": "${value}"}`,
    });

    const response = await idnResponse.json();
    // const failureEmails = response.failures?.map(
    //   (element: any) => element?.email,
    // );
    if (response?.failures?.length > 0) {
      validation.addError(
        `The owner/governance member must be a full time Principal employee`,
      );
    }

    if (response?.errors?.length > 0) {
      validation.addError(
        'Internal error occurred for email validation. Please try again later.',
      );
    }
  }
};

export const validateCustomGovernanceGroupMembership = async (
  value: any,
  validation: FieldValidation,
) => {
  const memList: Array<string> = value as Array<string>;
  const unique = new Set(memList);
  unique.forEach(member => {
    if (member === '') {
      unique.delete(member);
    }
  });
  const lowerUnique = new Set([...unique].map(m => m.toLowerCase()));
  if (lowerUnique.has(ownerInfo?.toLowerCase())) {
    validation.addError(
      'Owner will be automatically added to the governance group. Please select a different member email.',
    );
  }
  if (unique.size < 2) {
    validation.addError(
      'A minimum of two governance group members are required.',
    );
  } else {
    for (const member of value as Array<string>) {
      // const index: number = (value as Array<string>).indexOf(member);
      if (member) {
        await validateTextField(member, validation);
      } else {
        validation.addError(
          'Please enter a valid email address. E.g., lastname.firstname@principal.com or email@cuprum.cl',
        );
      }
    }
  }
};

export const validateOwnership = async (
  value: any,
  validation: FieldValidation,
) => {
  if (value) {
    await validateTextField(value, validation);
  } else {
    validation.addError('Please provide an email address for the team owner.');
  }
};
